<template>
  <div class="ad-batch-input">
    <div class="cell-input">
      <gj-textarea
        v-model="inputText"
        placeholder="请输入ASIN，一行一个，回车换行"
        :styles="{ 'border-color': this.errorKeyword ? '#F56C6C' : '', ...textareaStyles }">
      </gj-textarea>
    </div>
    <div class="cell-add">
      <span :class="{ red: errorKeyword }">ASIN不得包含特殊字符，如@、#、*和$等</span>
      <gj-button type="primary" @click="add" :disabled="!inputText" :loading="loadingInput">添加</gj-button>
    </div>
    <div class="cell-error">
      <gj-alert
        v-if="alert.error && alert.error.length !== 0"
        ref="gjAlert"
        type="error"
        show-icon
        closable
        @close="closeError">
        <template #title>
          <div>{{ `成功${alert.success.length || 0}个，失败${alert.error.length || 0}个` }}</div>
          <div class="alert-error">{{ `失败原因：ASIN格式不正确或ASIN重复添加，失败的ASIN：${alert.error.join("，")}`}}</div>
        </template>
      </gj-alert>
      <gj-alert
        v-else
        ref="gjAlert"
        type="success"
        show-icon
        closable
        @close="closeError">
        <template #title>
          <div class="alert-content">
            {{ `${alert.success.length || 0}个ASIN全部添加成功` }}
          </div>
        </template>
      </gj-alert>
    </div>
  </div>
</template>

<script>
export default {
  name: "ad-batch-input",
  props: {
    // 已选的项
    items: {
      type: Array,
      default: () => []
    },
    // 传入的前置校验
    beforeFn: {
      type: Function,
      default: async () => { return true }
    },
    // 传入的后置处理事件
    afterFn: {
      type: Function,
      default: async () => { return true }
    },
    value: {}
  },
  data() {
    return {
      inputText: null,
      loadingInput: false,
      textareaStyles: {
        height: '300px',
        fontSize: '12px',
        resize:"none"
      },
      alert: { // 错误提示
        success: [],
        error: [],
      },
    };
  },
  watch: {
    inputText(val) {
      this.$emit('input', val);
    }
  },
  computed: {
    errorKeyword() {
      return !/^[^!#%<>@*$]*$/.test(this.inputText);
    }
  },
  methods: {
    // 新增
    async add() {
      // 传入的前置校验
      const before = await this.beforeFn();
      if (!before) return false;
      this.loadingInput = true;
      this.alert.success = [];
      this.alert.error = [];
      const asinList = this.inputText.split('\n').map(item => item.replace(/^(\s|\n)+|(\s|\n)+?$/, '')); // 所有
      const items = this.items.map(e => e.asin);
      // 校验
      asinList.forEach(element => {
        let str = element.toUpperCase()
        let rule = /^[B|b]0[A-Za-z0-9]{8}$/.test(str);
        if (rule && !this.alert.success.includes(str) && !items.includes(str)) {
          this.alert.success.push(str);
        }else {
          this.alert.error.push(element);
        }
      });
      // 设置提示
      this.textareaStyles.height = '200px';
      this.$refs.gjAlert.$refs.alert.visible = true;
      // 传入的后置处理事件
      if(this.alert.success.length>0){
        const after = await this.afterFn(this.alert);
      }
      this.inputText = "";
      this.loadingInput = false;
    },
    // 关闭错误
    closeError() {
      setTimeout(() => {
        this.textareaStyles.height = '300px';
      }, 300);
    },
  },
  created() {},
  mounted () {
    this.$refs.gjAlert.$refs.alert.visible = false;
  },
};
</script>

<style scoped lang='scss'>
.ad-batch-input {
  margin: 10px 12px 0;
  font-size: 12px;
  white-space: normal;
  .cell-input {
    margin-top: 10px;
  }
  .cell-add {
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .cell-error {
    margin-top: 10px;
  }
  .red {
    color: #F56C6C;
  }
  .alert-error {
    max-height: 51px;
    overflow: auto;
  }
}
</style>